// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__VC3TB","label":"LabeledBox_label__1MXg-"};